<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局基础样式已统一在 src/styles/panke-theme.css */
</style>
